import { render } from "./Sections.vue?vue&type=template&id=3fa31c54&scoped=true"
import script from "./Sections.vue?vue&type=script&lang=js"
export * from "./Sections.vue?vue&type=script&lang=js"

import "./Sections.vue?vue&type=style&index=0&id=3fa31c54&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa31c54"]])

export default __exports__